export default "__VITE_ASSET__CURpJhD4__"